import { CalendarClock, Megaphone, Repeat } from 'lucide-react'
import { PlanUpsell } from '@/components/plan-upsell'
import { Badge } from '@/components/ui/badge'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'
import type { CampaignDerivedStatus } from '@/types/api'
import { DERIVED_STATUS_META } from '../lib/campaign-form'

export function CampaignStatusBadge({ status, className }: { status: CampaignDerivedStatus; className?: string }) {
  const meta = DERIVED_STATUS_META[status] ?? DERIVED_STATUS_META.draft
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Badge variant={meta.variant} className={className}>
          {meta.label}
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{meta.hint}</TooltipContent>
    </Tooltip>
  )
}

/** Campaign colour dot (falls back to a neutral swatch). */
export function CampaignSwatch({ color, className = 'size-3' }: { color: string | null | undefined; className?: string }) {
  return <span className={cn('inline-block shrink-0 rounded-full border border-black/10 bg-primary', className)} style={color ? { backgroundColor: color } : undefined} aria-hidden />
}

/** Shown instead of the campaign tools when the plan lacks the `campaigns` feature. */
export function CampaignsUpsell() {
  return (
    <PlanUpsell
      title="Group schedules into advertiser campaigns"
      description="Campaigns bundle schedules with shared dates, status and colour — pause or end a whole flight with one click."
      points={[
        { icon: Megaphone, text: 'Advertiser, code and colour per campaign' },
        { icon: CalendarClock, text: 'Campaign dates clip every schedule' },
        { icon: Repeat, text: 'Pause and resume in one step' },
      ]}
    />
  )
}
